import { Component, OnInit } from '@angular/core';
import { BiService } from '../../../services/bi.service';
import { DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-bi',
    templateUrl: './bi.component.html',
    styleUrls: ['./bi.component.scss'],
    standalone: false
})
export class BiComponent implements OnInit {

  company:any = [];
  activeReport:any = '';
  urlReport = 'https://app.powerbi.com/view?r=eyJrIjoiYWQyYTM2MGQtYTNkNS00YzFlLTllNDMtMzdkZjBlNDM1OGMwIiwidCI6IjI1M2U0MzhmLWNiNzUtNDNiYi1iYzQ4LTIzYjdkOWJkZjMyMSIsImMiOjJ9';
  
  constructor(private bi: BiService,private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.bi.getAll().subscribe((data:any) => {
      this.company = data.company;
    })

    this.activeReport = this.domSanitizer.bypassSecurityTrustResourceUrl(this.urlReport);

  }

  loadReport(report:any){
    this.activeReport = this.domSanitizer.bypassSecurityTrustResourceUrl(report.url);
  }

}
